import { render, staticRenderFns } from "./WithDropdown.vue?vue&type=template&id=a5945fc0"
import script from "./WithDropdown.vue?vue&type=script&lang=js"
export * from "./WithDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports